import * as React from "react";
function SvgNumber1(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M35.3 21.9c4.4-6.2 3-14.9-3.3-19.4s-15-3-19.4 3.2c-3.4 4.8-3.4 11.1-.1 15.9l.1.1L2.2 41.3l9.7-3.2 2.8 9.9L24 30.8 33.2 48l2.8-9.9 9.7 3.2c.1 0-10.4-19.4-10.4-19.4zM12.9 11.8c.9-5.4 5.6-9.4 11-9.4.6 0 1.4.1 2 .3 6.1 1.1 10.1 7 9.1 13-1 6.1-7 10.1-13 9.1-6.1-1.1-10.1-6.9-9.1-13zm2.5 29.1l-1.8-6.1-6.1 1.9 7-12.8c2 1.8 4.4 3 7.1 3.5l.9.1-.3.1.1.3-6.9 13zm18.7-6.1l-1.8 6.1-7-12.9.1-.3-.1-.1c2.9-.3 5.7-1.5 8-3.5l6.8 12.7c.1-.1-6-2-6-2zM22.6 11.9l.8-.8v8.3h2.5V8.2h-2.2l-3.5 3 1.1 1.5 1.3-.8z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgNumber1);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
